import {Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import { MenuModel } from '../../../../app-shared/models/menu.model';
import {
  SelectedUserSuppliersAndOutlets,
  SupplierOutletSettingsModel
} from '../../../../../app/app-shared/models/supplier-outlet.model';
import { MenuService } from '../menu.service';
import { takeUntil } from 'rxjs';
import { Subject } from 'rxjs';
import {CatalogService} from "../../../../catalog/catalog.service";
import {AuthService} from "../../../../app-shared";
import {Router} from "@angular/router";
import {SupplierOutletService} from "../../../../app-shared/services/supplier-outlet.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-more',
    templateUrl: './more.component.html',
    styleUrls: ['./more.component.scss'],
    standalone: false
})
export class MoreComponent implements OnInit {
  @Input() mainMenu: Array<MenuModel>;
  @Input() notificationCounter: number;
  @Output() navigateFormMenu = new EventEmitter<string>();
  @Output() isCloseMenu = new EventEmitter<boolean>();
  @Input() mobile: boolean;
  public supplierOutletSettings = new Array<SupplierOutletSettingsModel>();
  public supplierAndOutlet: SelectedUserSuppliersAndOutlets;
  isShowChangeOutlet = false;
  isShowUserNotifications = false;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private menuService: MenuService,
    private catalogService: CatalogService,
    private authService: AuthService,
    private router: Router,
    private supplierOutletService: SupplierOutletService,
  ) {}

  ngOnInit(){
     this.supplierOutletSettings = this.menuService.getSupplierOutletSettings();

     this.catalogService.changeSuppierAndOutlet
       .pipe(takeUntilDestroyed(this.destroyRef))
       .subscribe(() => {
         if (this.supplierOutletService.isUserSelectedSupplierAndOutlet()) {
           this.supplierAndOutlet = this.supplierOutletService.getUserSelectedSupplierAndOutlet();
         }
       this.supplierOutletSettings = this.menuService.getSupplierOutletSettings();
    });
  }

  clickMenu(item) {
    this.navigateFormMenu.emit(item);
    const el = document.getElementById('main-core-scroll');
    el.scrollTop = 0;
  }

  getSettingValue(settingName: string): string | undefined {
    const setting = this.supplierOutletSettings.find(s => s.settingName === settingName);
    return setting ? setting.settingValue : undefined;
  }

  closeMenu() {
    this.isCloseMenu.emit(true);
  }

  logout() {
    this.authService.logoutUser()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
      next: () => {
        this.router.navigate(['/start']).then(() => location.reload());
      },
      error: () => {
      },
    });
  }
}
